// Utility function to format time delta for node descriptions
export const formatTimeDelta = (timeDelta) => {
  // Handle undefined or null timeDelta
  if (timeDelta === undefined || timeDelta === null) {
    return '';
  }

  // Convert to number in case it's a string
  const delta = Number(timeDelta);
  
  // Handle invalid numbers
  if (isNaN(delta)) {
    return '';
  }

  // Handle "at time" case
  if (delta === 0) {
    return 'At ';
  }

  const absDelta = Math.abs(delta);
  const isAfter = delta > 0;
  const prefix = isAfter ? 'after' : 'before';

  let timeString = '';

  if (absDelta < 60) {
    // Minutes
    const unit = absDelta === 1 ? 'minute' : 'minutes';
    timeString = `${absDelta} ${unit}`;
  } else if (absDelta < 1440) {
    // Hours (less than 24 hours = 1440 minutes)
    const hours = absDelta / 60;
    const wholeHours = Math.floor(hours);
    const remainingMinutes = absDelta % 60;
    
    if (remainingMinutes === 0) {
      // Whole hours
      const unit = wholeHours === 1 ? 'hour' : 'hours';
      timeString = `${wholeHours} ${unit}`;
    } else if (remainingMinutes === 30) {
      // Half hours
      const unit = hours === 1.5 ? 'hour' : 'hours';
      timeString = `${hours} ${unit}`;
    } else {
      // Hours and minutes
      const hourUnit = wholeHours === 1 ? 'hour' : 'hours';
      const minuteUnit = remainingMinutes === 1 ? 'minute' : 'minutes';
      timeString = `${wholeHours} ${hourUnit} ${remainingMinutes} ${minuteUnit}`;
    }
  } else {
    // Days (1440+ minutes)
    const days = absDelta / 1440;
    const wholeDays = Math.floor(days);
    const remainingMinutes = absDelta % 1440;
    
    if (remainingMinutes === 0) {
      // Whole days
      const unit = wholeDays === 1 ? 'day' : 'days';
      timeString = `${wholeDays} ${unit}`;
    } else if (remainingMinutes === 720) {
      // Half days
      const unit = days === 1.5 ? 'day' : 'days';
      timeString = `${days} ${unit}`;
    } else {
      // Days and hours (simplified to show major units)
      const remainingHours = Math.floor(remainingMinutes / 60);
      if (remainingHours > 0) {
        const dayUnit = wholeDays === 1 ? 'day' : 'days';
        const hourUnit = remainingHours === 1 ? 'hour' : 'hours';
        timeString = `${wholeDays} ${dayUnit} ${remainingHours} ${hourUnit}`;
      } else {
        const dayUnit = wholeDays === 1 ? 'day' : 'days';
        timeString = `${wholeDays} ${dayUnit}`;
      }
    }
  }

  return `${timeString} ${prefix} `;
};